function ViewBook() {
  return (
    <>
      View Book
    </>
  );
}

export default ViewBook;
